import { getSVG } from '@/components/Common/styles/mixins';
import React from 'react';

import styles from './RaffleDealPrepare.module.scss';

const RaffleDealPrepare: React.FC = () => {
  return (
    <div className={styles.drawPrepareContainer}>
      <p className={styles.drawPrepareTitle}>상품 준비 중입니다</p>
      <p className={styles.drawPrepareSubTitle}>빠른 시일 내에 돌아올게요</p>
      <img
        className={styles.drawPrepareImg}
        src={getSVG('/static/images/promotion/raffle-deal/draw_preparing.png')}
        alt={'상품 준비 중입니다. 빠른 시일 내에 돌아올께요.'}
      />
    </div>
  );
};

export default RaffleDealPrepare;
